import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

interface Assignment {
  survey_id: string;
  survey_title: string;
  employee_id: string;
  employee_name: string;
  customer_count: number;
}

@Component({
  selector: 'app-assignment-listing',
  templateUrl: './assignment-listing.component.html',
  styleUrls: ['./assignment-listing.component.css']
})
export class AssignmentListingComponent implements OnInit {
  assignments: Assignment[] = [];
  dataLoaded = false;
  error = '';

  private baseUrl = 'https://test.shajipaints.com/dev/FactoryCustomerSurvey';

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadAssignments();
  }

  loadAssignments(): void {
    this.error = '';

    this.http.get<any>(`${this.baseUrl}/viewAssignments`).subscribe({
      next: (response) => {
        if (response.success && response.data) {
          this.assignments = response.data.map((item: any) => ({
            survey_id: item.survey_id,
            survey_title: item.survey_title,
            employee_id: item.employee_id,
            employee_name: item.employee_name,
            customer_count: item.customers?.length || 0
          }));
        } else {
          this.error = 'Failed to load assignments';
        }
        this.dataLoaded = true;
      },
      error: (err) => {
        console.error('Error loading assignments:', err);
        this.error = 'Error loading assignments. Please try again.';
        this.dataLoaded = true;
      }
    });
  }

  createNewAssignment(): void {
    this.router.navigate(['admin/customer-survey-menu/assignment']);
  }

  viewAssignmentDetail(surveyId: string): void {
    this.router.navigate(['admin/customer-survey-menu/assignment-detail', surveyId]);
  }
}